import { middlewareInstance } from "./middlewareInstance";
import { addLocaleToUrl } from "../state/utils/modifyUrl";

export const getUserReservations = async (params) => {
  try {
    const data = await middlewareInstance.get(
      `/api/v1/reservations?page=${params.page}&per_page=${params.per_page}&filter_type=${params.filter_type}`,
      {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      }
    );

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const getUserVoucers = async (params) => {
  try {
    const { data } = await middlewareInstance.get(`/api/v1/vouchers`, {
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    });

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const getUserPointsHistory = async (params) => {
  try {
    const data = await middlewareInstance.get(
      `/api/v1/transactions?page=${params.page}&per_page=${params.per_page}`,
      {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      }
    );

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const submitFeedbackForm = async (params, token) => {
  try {
    const data = await middlewareInstance.post(`/api/v1/feedbacks`, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const submitChangeProfileForm = async (guest_id, params, token) => {
  try {
    const data = await middlewareInstance.put(
      `/api/v1/guests/${guest_id}`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const getRewardDetail = async (requestParams) => {
  try {
    const response = await middlewareInstance.get(
      `/api/v1/redemptions/${requestParams.id}`,
      {
        headers: {
          Authorization: `bearer ${requestParams.token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const getItemLocation = async (tag) => {
  try {
    const response = await middlewareInstance.get(
      tag
        ? `/api/v1/redemptions/locations?tag=${tag}`
        : `/api/v1/redemptions/locations`
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const getRewardCategories = async () => {
  try {
    const response = await middlewareInstance.get(
      "/api/v1/redemptions/categories"
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const getRewards = async ({
  page,
  min_price,
  max_price,
  property,
  category_id,
}) => {
  try {
    const response = await middlewareInstance.get(
      `/api/v1/redemptions?page=${page}&min_price=${min_price}&max_price=${max_price}&property=${property}&category_id=${category_id}`
    );
    return response;
  } catch (error) {
    throw new Error();
  }
};

export const submitUnsubscribeForm = async (params) => {
  try {
    const data = await middlewareInstance.put(
      `/api/v1/guests/unsubscribe`,
      params
    );

    return data;
  } catch (error) {
    throw new Error();
  }
};

export const generateUnsubscriptionLink = async (requestParams) => {
  try {
    const response = await middlewareInstance.get(
      `/api/v1/subscriptions/generate_unsubscribe_link?email=${requestParams.email}&campaign_id=${requestParams.campaignId}`
    );

    if (response.data && response.data.link) {
      let url = addLocaleToUrl(response.data.link, requestParams.locale);
      window.location.href = url;
    } else {
      console.error("Link not found in the response");
    }
  } catch (error) {
    console.error("API call failed:", error);
  }
};
